export function isValidEventId(eventId) {
  return eventId !== "" &&
    eventId !== "--" &&
    eventId !== null &&
    eventId !== "null" &&
    eventId !== undefined &&
    eventId !== "undefined" &&
    eventId !== "false" &&
    eventId !== false;
}



// WEBPACK FOOTER //
// ./src/helpers/utils.helper.ts